require('../scss/style.scss');

require('slick-carousel');

require('popper.js');
require('bootstrap');
var noUiSlider = require('nouislider');

const Rellax = require('rellax');

var Headroom = require('headroom.js');

var lozad = require('lozad');

require('jquery-sticky');

require('@fancyapps/fancybox/dist/jquery.fancybox.js');

const Swal = require('sweetalert2');

jQuery(window).on('load', function() {
  jQuery("body").removeClass("preload");
});


var wWidth = $(window).width();


window.initMap = function initMap() {
	var mapElm = document.getElementById("map");
	const myLatLng = { lat: parseFloat(mapElm.dataset.lat), lng: parseFloat(mapElm.dataset.lng) };
  	const map = new google.maps.Map(mapElm, {
	    zoom: 15,
	    center: myLatLng
	  });
	  new google.maps.Marker({
	    position: myLatLng,
	    map,
	    title: "Lamborghini Bordeaux"
	  });
}


jQuery(document).ready(function ($) {

	document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);

	var wWidth = $(window).width();
	var wHeight = $(window).height();
	var isSmallScreen = wWidth < 768;
	var bgBreakPoint = 1024;
	var breakPointBgChange = false;


	$( window ).resize(function() {
		wWidth = $(window).width();
		wHeight = $(window).height();
		isSmallScreen = wWidth < 768;
	});


	inlineBg(wWidth <= bgBreakPoint);

	// Inline BG Function
	function inlineBg(isMobile) {
		$("[data-bg]").each(function () {
			var dataImg = $(this).data('bg');
			
			if (dataImg.match(/\s/g)) {
				dataImg = dataImg.split(' ');
				var baseImg = dataImg[0];
				var mobileImg = dataImg[1];
				if (isMobile && mobileImg) {
					$(this).css('background-image', 'url(' + mobileImg + ')');
				}
				else {
					$(this).css('background-image', 'url(' + baseImg + ')');
				}
			}
			else {
				$(this).css('background-image', 'url(' + dataImg + ')');
			}
		});
	}

	var baseHeader = document.querySelector("header");
	var headroom  = new Headroom(baseHeader, {
		tolerance: {
            down : 10,
            up : 20
        },
        offset : 15,
	});
	headroom.init();




	$('.main-slider').slick({
		slide: '.slide',
		fade: true,
		speed: 850,
		rows: 0,
		arrows: false,
		autoplay: true,
  		autoplaySpeed: 5000,
		dots: true,
		draggable: false,
		touchMove: false,
		draggable: false,
	});

	$('.main-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	  $(slick.$slides[nextSlide]).addClass('progress');
	})
	$('.main-slider').on('afterChange', function(event, slick, currentSlide){
	  $(slick.$slides[currentSlide]).removeClass('progress');
	})

	if ($('.rellax').length) {
		var rellax = new Rellax('.rellax', {

		});
	}

	$('.inner-page-slider').each(function() {
		var parentElm = $(this);
		var sliderElm = parentElm.find('.page-slider');
		sliderElm.slick({
			fade: true,
			speed: 850,
			rows: 0,
			arrows: true,
			dots: false,
			adaptiveHeight: true,
			draggable: false,
			touchMove: false,
			draggable: false,
			autoplay: true,
  			autoplaySpeed: 5000,
			prevArrow: parentElm.find('.btn-prev'),
			nextArrow: parentElm.find('.btn-next')
		});
	});


	$('.slider-model-images .slides').slick({
		fade: true,
		speed: 850,
		rows: 0,
		arrows: true,
		dots: false,
		draggable: false,
		touchMove: false,
		draggable: false,
		autoplay: true,
  		autoplaySpeed: 5000,
		prevArrow: $('.slider-model-images .btn-prev'),
		nextArrow: $('.slider-model-images .btn-next'),
		responsive: [
	    {
	      breakpoint: 992,
	      settings: {
	        fade: false,
	        arrows: false,
	        slidesToShow: 1.5,
			centerMode: true,
			draggable: true,
			touchMove: true,
			draggable: true,
	      }
	    },
	    {
	      breakpoint: 768,
	      settings: {
	      	centerMode: false,
	      	fade: false,
	        slidesToShow: 1,
	        arrows: false,
	        draggable: true,
			touchMove: true,
			draggable: true,
	      }
	    }]
	});
	
	

	
	$('#main_menu_nav li.level-0').each(function() {
		var minMenuH = 0;

		$(this).find('.submenu').each(function() {
			var currentSubHeight = $(this).outerHeight();
			if (currentSubHeight > minMenuH) {
				minMenuH = currentSubHeight;
			}
		});
		$(this).find('.submenu').each(function() {
			$(this).height(minMenuH);
		});
	});


	$('#toggle_m_menu').on('click', function() {
		$('body').toggleClass('m-menu-open');
		$(this).toggleClass('open');
		$('#main_menu_nav').toggleClass('m-menu-open');
		if (!$(this).hasClass('open')) {
			setTimeout(function() {
				$('#main_menu_nav *').removeClass('sub-active');
	    		$('#main_menu_nav *').removeClass('current');
			}, 500);
		}
	});


	var currentMobileMenuLevel = 0;

	if (wWidth <= 992) {

		$('#main_menu_nav li.parent-item.level-0 > a').on('click', function(e) {
			e.preventDefault();

			currentMobileMenuLevel = 1;
			$('#main_menu_nav li.level-0').addClass('sub-active');
			var cSub = $(this).parent().find('.submenu');
			if (cSub.length) {
				cSub.addClass('current');
				var cSubChild = cSub.find('.submenu');
				if (cSubChild.length) {
					cSubChild.removeClass('current');
				}
			}

			return false;
		});

		$('#main_menu_nav li.parent-item.level-1 > a').on('click', function(e) {
			e.preventDefault();

			currentMobileMenuLevel = 2;
			$('#main_menu_nav li.level-1').addClass('sub-active');
			var cSub = $(this).parent().find('.submenu');
			if (cSub.length) {
				cSub.addClass('current');
			}

			return false;
		});
	}



	var mobileBtnReturn = false;
	createMobileReturnBtn();
	function createMobileReturnBtn() {
		if (!mobileBtnReturn && wWidth <= 992) {
			$('#main_menu_nav .parent-item.level-0').each(function() {
				$(this).find('.submenu').first().prepend('<li class="sub-active"><a class="m-return-btn d-flex align-items-center" href="javascript:void(0);"><span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.464 58.271" class="exagon left"><g stroke-width="1.5" transform="translate(-1624 -187.923)"><path class="background exagon" d="M50.464 43.992L25.732 58.271 1 43.992V15.434L25.732 1.155l24.732 14.279z" transform="translate(1623.5 187.345)"></path><path class="foreground left" d="M0 5.675L7.432 0l7.432 5.675" transform="rotate(-90 935.432 -711.068)"></path></g></svg></span><span>&nbsp;Retour</span></a></li>');
			});

			var socialMenu = $('ul.social').clone();

			$('#main_menu_nav').append('<li class="level-0 m-social"></li>');
			$('li.m-social').append(socialMenu);

    		mobileBtnReturn = true;
    	}
	}

	$(document).on('click', '.m-return-btn', function() {
		currentMobileMenuLevel --;

		if (currentMobileMenuLevel == 0) {
			$('#main_menu_nav *').removeClass('sub-active');
	    	$('#main_menu_nav *').removeClass('current');
		}
		if (currentMobileMenuLevel == 1) {
			$('#main_menu_nav li.level-1').removeClass('sub-active');
			$('#main_menu_nav li.parent-item.level-1 .submenu').removeClass('current');
		}

	});

	// Resize Handle
	$(window).resize(function() {
	    wWidth = $(window).width();
	    createMobileReturnBtn();
	    if (wWidth > 992) {
	    	currentMobileMenuLevel = 0;
	    	mobileBtnReturn = false;
	    	$('body').removeClass('m-menu-open');
	    	$('#toggle_m_menu').removeClass('open');
	    	$('#main_menu_nav').removeClass('m-menu-open');
	    	$('#main_menu_nav *').removeClass('sub-active');
	    	$('#main_menu_nav *').removeClass('current');
	    	$('.m-return-btn').remove();
	    	$('li.m-social').remove();
	    }


	    if (wWidth > 1024) {
	    	initModelSLider();
	    }
	    else {
	    	destroyModelSLider();
	    }

	});

	const observer = lozad(); // lazy loads elements with default selector as '.lozad'
	observer.observe();


	setTimeout(function() {
		$('.models-slider').addClass('loaded');
	}, 500);

	var maxModelSlides;
	var currentModelSlide;

	if (wWidth > 1024) {
		initModelSLider();
	}
	else {
		$('.models-slider').addClass('mobile');
	}

	function initModelSLider() {

		$('.models-slider').removeClass('mobile');

		maxModelSlides = $('.models-slider .slides .slide').length;
		currentModelSlide = maxModelSlides-1;

		$('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').addClass('active');
		modelsSlideNext(true);
	}

	function destroyModelSLider() {
		$('.models-slider').addClass('mobile');
		maxModelSlides = $('.models-slider .slides .slide').length;
		currentModelSlide = maxModelSlides-1;

		$('.models-slider .slides .slide').removeClass('active');

		$('.models-slider .slides .slide').sort(function(a, b) {
		    return +a.dataset.index - +b.dataset.index;
		})
		.appendTo($('.models-slider .slides'));

	}

	function modelsSlideNext(init) {
		$('.family-info').addClass('changing');

		var oldModelSlide = currentModelSlide;

		if (init == false) {
			if (currentModelSlide == 0) {
				currentModelSlide = maxModelSlides-1;
			}
			else {
				currentModelSlide --;
			}

			$('.models-slider .slides .slide').removeClass('active');
			$('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').addClass('active');

			setTimeout(function() {
				$('.family-info').html($('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').find('.texts').html());
			}, 500);

			$('.models-slider .slides').prepend($('.models-slider .slides .slide[data-index="'+oldModelSlide+'"]').clone());
			setTimeout(function() {
				$('.models-slider .slides .slide[data-index="'+oldModelSlide+'"]').last().remove();
				$('.family-info').removeClass('changing');
			}, 500);
		}
		else {
			$('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').addClass('active');
			$('.family-info').html($('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').find('.texts').html());
			$('.family-info').removeClass('changing');
		}
	}

	$('.models-slider .controls a.btn-next').on('click', function() {
		if (wWidth > 1024) {
			modelsSlideNext(false);
		}
	});

	$('[data-fancybox="gallery"]').fancybox({
        thumbs : {
            showOnStart : true
        },
        hash : true
    });
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 5,
        centerMode: false,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: true,
        arrows: false,
        infinite: false,
        focusOnSelect: true
    });

	$('.models-slider .controls a.btn-prev').on('click', function() {
		if (wWidth > 1024) {
			$('.family-info').addClass('changing');

			var oldModelSlide = currentModelSlide;
			if (currentModelSlide == maxModelSlides-1) {
				currentModelSlide = 0;
			}
			else {
				currentModelSlide ++;
			}
			
			// $('.models-slider .slides').append($('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]'));
			$('.models-slider .slides').append($('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').clone());
			
			$('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').last().addClass('active');

			setTimeout(function() {
				$('.models-slider .slides .slide[data-index="'+oldModelSlide+'"]').last().removeClass('active');
				
			}, 10);

			setTimeout(function() {
				$('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').first().remove();
				$('.family-info').html($('.models-slider .slides .slide[data-index="'+currentModelSlide+'"]').find('.texts').html());
				$('.family-info').removeClass('changing');
			}, 500);
		}

	});

	$('.models-slider .slides').slick({
	    slidesToShow: 1,
	    fade: true,
	    mobileFirst: true,
	    infinite: true,
	    prevArrow: $('.models-slider .btn-prev'),
		nextArrow: $('.models-slider .btn-next'),
	    responsive: [
			{
				breakpoint: 1024,
				settings: 'unslick'
			}
	    ]
	  });

	var ctaFixed = false;
	$(window).scroll(function(){
	    if ($('.model-details').length) {
	    	var scrTop = $('.main-slider').outerHeight() / 2;

	    	if ($(this).scrollTop() > scrTop) {
	    		if (ctaFixed == false) {
	    			$('.cta-footer').addClass('inscreen');
	    			ctaFixed = true;	
	    		}
	    	}
	    	else {
	    		if (ctaFixed == true) {
		    		$('.cta-footer').removeClass('inscreen');
		    		ctaFixed = false;	
		    	}
	    	}
	    }
	});


	var vehicleFiltersInit = false;

	var priceSlider = document.getElementById('price_slider');
	if ($(priceSlider).length) {

		var sliderMin = $(priceSlider).attr('data-min');
		var sliderMax = $(priceSlider).attr('data-max');

		sliderMin = sliderMin == sliderMax ? 0 : sliderMin;

		sliderMin = parseInt(sliderMin);
		sliderMax = parseInt(sliderMax);

		noUiSlider.create(priceSlider, {
			tooltips: false,
		    start: [sliderMin, sliderMax],
		    step: 2000,
		    connect: true,
		    range: {
		        'min': sliderMin,
		        'max': sliderMax
		    }
		});

		priceSlider.noUiSlider.on('update.one', function (values, handle, unencoded, tap, positions, noUiSlider) {

			if (vehicleFiltersInit == true) {
				var cFrom = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumSignificantDigits: 3 }).format(values[0]);
				var cTo = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumSignificantDigits: 3 }).format(values[1]);

				$('#price_values').html(cFrom+' - '+cTo);
			}
			else {
				vehicleFiltersInit = true;
			}

		});

		priceSlider.noUiSlider.on('change.one', function (values, handle, unencoded, tap, positions, noUiSlider) {

			updateVehicles(true);

		});
	}


	

	$('.sidebar .filters input, .sidebar select').on('change', function() {
		updateVehicles(false);
	});


	var filteredVehicles = [];
	var filteredStr = [];


	function updateVehicles(wPrice) {

		var hasSelect = false;
		$('.sidebar select').each(function() {
			if (hasSelect == false && $(this).val()) {
				hasSelect = true;
			}
		});

		if ($('.sidebar .filters input:checked').length == 0 && wPrice == false && hasSelect == false) {
			$('.vehicle-item').show();
			$('#no_vehicles').addClass('hide');
		}
		else {

			filteredVehicles = [];
			filteredStr = [];

			$('.vehicle-item').hide();
			$('#no_vehicles').addClass('hide');

			$('.sidebar .filters input').each(function() {
				var inputConfig = $(this).attr('id').split('_');
				if ($(this).is(':checked')) {
					filteredStr.push('[data-'+inputConfig[1]+'="'+inputConfig[2]+'"]');
				}
			});

			var price = priceSlider.noUiSlider.get();
			var stF = parseInt(price[0]);
			var stT = parseInt(price[1]);

			filteredStr = filteredStr.join('');

			filteredStr = filteredStr ? filteredStr : '[data-price]';

			if (filteredStr) {
				if ($('*'+filteredStr).length) {

					var totalItems = 0;

					$('*'+filteredStr).each(function() {

	
						var elmPrice = $(this).attr('data-price');

						elmPrice = parseInt(elmPrice);


						var elmYear = $(this).attr('data-annee');
						elmYear = parseInt(elmYear);
						var stYF = $('#filter_anneemin').val();
						var stYT = $('#filter_anneemax').val();
						stYF = stYF ? stYF : 0;
						stYT = stYT ? stYT : 9999;
						if (elmYear && elmYear >= stYF && elmYear <= stYT) {


							if (elmPrice && elmPrice >= stF && elmPrice <= stT) {
								$(this).show();
								totalItems ++;
							}
							else {
								$(this).hide();
							}

						}
						else {
							if ($(this).is(':visible')) {
								$(this).hide();
							}
						}
						
					});

					if (totalItems == 0) {
						$('#no_vehicles').removeClass('hide');
					}


				}
				else {
					$('#no_vehicles').removeClass('hide');
				}
			}


		}

		
	}

	$('.form form').each(function() {

        var cForm = $(this);

        cForm.on('submit', function(e) {

            e.preventDefault();

            $.ajax({
                type: 'POST',
                url: '/',
                async: true,
                data: cForm.serialize(),
                success(data) {
                    data = JSON.parse(data);
                    if (data.success) {

                        cForm.find('input').attr('disabled', 'disabled');
                        cForm.find('textarea').attr('disabled', 'disabled');
                        cForm.find('input').val('');
                        cForm.find('textarea').val('');

                        Swal.fire({
                          title: 'Merci !',
                          icon: 'success',
                          html: 'Votre demande nous a bien été envoyée.',
                          showCancelButton: false,
                          confirmButtonText: 'OK',
                        });
                    }
                    else {
                        if (data.error) {
                            alert(data.error);
                        }
                        else {
                            alert('Problème lors votre envoi');
                        }
                    }
                },
                error(data) {
                    alert('Problème lors votre envoi');
                }
            });
            return false;
        });
    });

	// if ($(".sticky-sidebar").length) {
	// 	fixAside();
	// }

	// function fixAside() {
	// 	var topSpacing = 124;
	//     if (!isSmallScreen) {
	//         var footerH = $('footer.footer').outerHeight() + 80;

	//         if (wHeight > $(".sticky-sidebar").outerHeight()) {
	//             $(".sticky-sidebar").sticky({
	//                 topSpacing: topSpacing,
	//                 bottomSpacing: footerH
	//             });
	//             $(".sticky-sidebar").on('sticky-start', function () {
	//                 $(this).closest('.sticky-wrapper').addClass('sticky');
	//             });
	//             $(".sticky-sidebar").on('sticky-end', function () {
	//                 $(this).closest('.sticky-wrapper').removeClass('sticky');
	//             });
	//         }
	//         else {
	//         	$(".sticky-sidebar").unstick();
	//         }
		    
	//     }
	//     else {
	//     	$(".sticky-sidebar").unstick();
	//     }
	// }


});
